// eslint-disable-next-line import/prefer-default-export
export const formData = (fields) => {
  const data = new FormData();
  Object.keys(fields).forEach((field) => {
    if (field === "tags")
      data.append(
        field,
        fields[field].value.map((tag) => tag.slice(0, tag.lastIndexOf("/")))
      );
    else if (field !== "imageFile") data.append(field, fields[field].value.toString());
    else if (fields[field].value !== null) data.append(field, fields[field].value);
  });
  return data;
};
